import React, { useState } from 'react'
import SidePanel, { useSidePanel } from '@node-space/storybook-components/dist/SidePanel'
import { Avatar, Box, Highlight, Text } from '@node-space/ui-components'
import { Customer, CustomerStatus } from 'types/customers'
import { StatusLabelMapping, StatusMapping } from '../constants'
import CustomerListItem from './CustomerListItem'
import { SidePanelCustomerBody } from './SidePanelCustomerBody'

interface CustomersListProps {
  customers: Customer[]
}

const CustomersList = ({ customers }: CustomersListProps) => {
  const [activeRowId, setActiveRowId] = useState(null)

  const {
    isSidePanelOpen: isCustomerOpen,
    sidePanelData: customerData,
    paging: pagingCustomerList,
    setIsSidePanelOpen: setIsCustomerOpen,
    updateSidePanel: updateCustomer,
  } = useSidePanel(customers)

  return (
    <>
      <Box flexCol hasBorder divideChildren>
        {customers?.map((customer, index) => {
          return (
            <Box key={customer?.reference}>
              <CustomerListItem
                index={index}
                key={customer?.reference}
                customerId={customer?.reference}
                name={customer?.name}
                description={customer?.description}
                status={customer?.status}
                setIsCustomerOpen={setIsCustomerOpen}
                updateCustomer={updateCustomer}
                activeRowId={activeRowId}
              />
            </Box>
          )
        })}
        <SidePanel
          isOpen={isCustomerOpen}
          onClose={() => setIsCustomerOpen(false)}
          paging={pagingCustomerList}
          scrollBody={false}
          activeRowId={customerData?.reference}
          onActiveRowChange={id => setActiveRowId(id)}
          sidePanelHeader={{
            customSidePanelHeader: (
              <Box flex width="full" paddingY={12}>
                <Avatar
                  size="large"
                  type="entity"
                  name={customerData?.name?.charAt(0)?.toUpperCase() || ''}
                />
                <Box flexCol flexSize="fill" paddingL={16} gapY={4}>
                  <Text variant="heading-2" className="leading-6">
                    {customerData?.name}
                  </Text>
                  <Text colour="subdued" className="leading-4">
                    {customerData?.description}
                  </Text>
                  {customerData?.status !== CustomerStatus.VERIFIED && (
                    <Box>
                      <Highlight type={StatusMapping[customerData?.status]} variant="status">
                        {StatusLabelMapping[customerData?.status]}
                      </Highlight>
                    </Box>
                  )}
                </Box>
              </Box>
            ),
          }}
        >
          <Box flex flexCol paddingX={20} paddingY={24} gapY={12}>
            <SidePanelCustomerBody customerId={customerData?.reference} />
          </Box>
        </SidePanel>
      </Box>
    </>
  )
}

export default CustomersList
